import React from 'react';

import IconType from '../../../types/Icon';

const Clock2: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox={`0 0 ${size} ${size}`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M24 0C10.7656 0 0 10.7656 0 24C0 37.2344 10.7656 48 24 48C37.2344 48 48 37.2344 48 24C48 20.0781 47.0469 16.3984 45.375 13.125L42.375 16.125C43.1641 17.9609 43.6641 19.9297 43.875 22H40V26H43.875C42.9453 35.4531 35.4531 42.9453 26 43.875V40H22V43.875C12.5469 42.9453 5.05469 35.4531 4.125 26H8V22H4.125C5.05469 12.5469 12.5469 5.05469 22 4.125V8H26V4.125C29.0938 4.4375 31.9844 5.4375 34.5 7L37.4375 4.125C33.6094 1.53125 28.9609 0 24 0ZM44.5625 2.5625L24 23.125L17.4375 16.5625L14.5625 19.4375L22.5625 27.4375L24 28.8125L25.4375 27.4375L47.4375 5.4375L44.5625 2.5625Z"
				fill={color}
			/>
		</svg>
	);
};

export default Clock2;
